export enum MODAL_ACTION {
  CREATE_JOB = 'create-job',
  CANCEL_JOB = 'cancel-job',
}
